import devConfig from './development.json'
import euConfig from './eu.json'
import prodConfig from './production.json'

declare global {
  interface Window {
    DRIFT_CONFIG: any
    DRIFT_REGION: string
    __ENV__: string
  }
}

const localConfigs: any = {
  QA: devConfig,
  EU: euConfig,
  US: prodConfig,
}

export default {
  SENTRY_DSN:
    'https://e5ed338ec3cd45ea877f3ca6a569c17f@o13824.ingest.sentry.io/4503983080341504',
  ...(window.DRIFT_CONFIG || {}),
  ...localConfigs[
    window.DRIFT_REGION || (window.__ENV__ === 'PRODUCTION' ? 'US' : 'QA')
  ],
}
